import React from "react";
import { IconButton } from "@sscs/ui";
import {
  CloseIcon,
  HighlightOffIcon,
  IconComponent,
  InfoIcon,
  WarningOutlineIcon,
} from "@sscs/ui/icons";
import { getClassName } from "@sscs/utils";
import { AnnouncementStyle } from "Types";
import useAnnouncements from "../../hooks/useAnnouncements";
import styles from "./banner.module.scss";

const GLYPH_BY_STYLE: Record<AnnouncementStyle, IconComponent> = {
  info: InfoIcon,
  warning: WarningOutlineIcon,
  error: HighlightOffIcon,
};

const Banner = (): React.JSX.Element => {
  const { unseenAnnouncements: announcements, dismissAnnouncement } =
    useAnnouncements();

  const bannerMessages = announcements.map((announcement) => {
    const Glyph = GLYPH_BY_STYLE[announcement.announcementStyle];

    return (
      <li
        key={announcement.announcementId}
        className={getClassName(
          styles.banner,
          styles[announcement.announcementStyle],
        )}
      >
        <Glyph className={styles.glyph} />
        <span className={styles.announcement}>
          {announcement.message.map((message, index) =>
            message.textStyle === "bold" ? (
              <strong key={index}>{message.text}</strong>
            ) : (
              <span key={index} className={styles.regular}>
                {message.text}
              </span>
            ),
          )}
        </span>
        <IconButton
          aria-label="Close"
          className={styles.closebutton}
          size="small"
          onClick={() => dismissAnnouncement(announcement.announcementId)}
        >
          <CloseIcon />
        </IconButton>
      </li>
    );
  });

  return (
    <>
      {bannerMessages.length > 0 && (
        <div className={styles.root}>
          <ul className={styles["message-list"]}>{bannerMessages}</ul>
        </div>
      )}
    </>
  );
};

export default Banner;
